import type { ComponentType, ReactNode, SVGProps } from 'react';

type Props = {
  badge?: 'ok' | 'stop' | 'info' | 'warm' | 'gold';
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  eyebrow?: string;
  title?: string;
  body?: string;
  meta?: ReactNode;
  actions?: ReactNode;
  doc?: boolean;
};

const RResult = ({ badge, icon: Ic, eyebrow, title, body, meta, actions, doc }: Props) => (
  <div className={`rg-screen rg-result${doc ? ' rg-result-doc' : ''}`}>
    <div className="rg-inner">
      {Ic && (
        <div className={`rg-result-badge ${badge || 'ok'}`}>
          <Ic />
        </div>
      )}
      {eyebrow && <div className="rg-eyebrow">{eyebrow}</div>}
      {title && <h1 className="rg-result-h">{title}</h1>}
      {body && <p className="rg-result-p">{body}</p>}
      {meta && <div className="rg-result-meta">{meta}</div>}
      {actions && (
        <div className="c-btnset" style={{ maxWidth: 340, marginTop: 8 }}>
          {actions}
        </div>
      )}
    </div>
  </div>
);

export { RResult };
